import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {
	AuthorizationsParams,
	GetAuthRequests,
	GetAuthRequestsModel,
} from 'domain/usecases/private/authorizations';

export class RemoteGetAuthRequests implements GetAuthRequests {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAuthRequestsModel>,
	) {}

	async get(params?: AuthorizationsParams): Promise<GetAuthRequestsModel> {
		const {signal, ...restParams} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: restParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
